
import React from "react";

const SectionHeader = ({ title, description }) => (
    <div className="home-section-header">
        <h2>{title}</h2>
<br/>
        {description && (
            <p>{description}</p>
        )}
    </div>
);

export default SectionHeader;